var map = {
	"./en/Partners_Giannothanasis": [
		"5d20",
		"chunk-483a6fe2"
	],
	"./gr/Partners_Giannothanasis": [
		"72ef",
		"chunk-ceba6700"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "54a3";
module.exports = webpackAsyncContext;